
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.02"><defs><linearGradient id="a" x1="9" x2="9" y1="16.97" y2="1.03" gradientTransform="translate(-1 -1)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#0078d4"/><stop offset=".16" stop-color="#1380da"/><stop offset=".53" stop-color="#3c91e5"/><stop offset=".82" stop-color="#559cec"/><stop offset="1" stop-color="#5ea0ef"/></linearGradient></defs><path fill="url(#a)" d="M16 3v9.74l-4 3.28-6.2-2.26V16l-3.51-4.59 10.23.8V3.44Zm-3.41.49L6.85 0v2.29L1.58 3.84 0 5.87v4.61l2.26 1V5.57Z" style="fill:url(#a)"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    